import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Remember if a SW was already in control (false = first install, true = update)
    const hadController = !!navigator.serviceWorker.controller;

    navigator.serviceWorker
      .register('/service-worker.js', { updateViaCache: 'none' })
      .then((reg) => {
        reg.update(); // Check for new build on every app open
      })
      .catch((err) => {
        console.error('[SW] Registration failed:', err);
      });

    // New SW took over → reload so the page runs new code
    // Guard with hadController so first-install doesn't trigger a reload
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (hadController) {
        window.location.reload();
      }
    });
  });
}
